import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Carousel } from '@grandvisionhq/common';
import { Measurement } from '../Measurement/Measurement.js';

const MeasurementCarousel = ({ measurements  })=>{
    return /*#__PURE__*/ React.createElement(Carousel, {
        pagination: true
    }, measurements.map((item)=>/*#__PURE__*/ React.createElement(Measurement, swcHelpers.extends({}, item, {
            key: item.key
        }))
    ));
};

export { MeasurementCarousel };
//# sourceMappingURL=MeasurementCarousel.js.map
